<template>
  <div class="bg">
    <div id="login">
      <div class="text-center"><img class="mb-3" height="50" src="/static/logo@2x.png" /></div>
      <div class="alert alert-danger mt-4" v-show="loginStatus == 1" role="alert">
        <span class="text-small">Kullanıcı adı ve ya parolanız hatalı</span>
      </div>
      <form name="ctl01" id="ctl01" class="newform">
        <div class="form-group">
            <input name="_username" type="text" v-model="username" maxlength="32" id="_username" 
              class="form-control" autocomplete="off" aria-describedby="inputUsernameHelp" placeholder="kullanıcı adınız" required="" />
            <label for="lblUsername">Kullanıcı Adı</label>
        </div>
        <div class="form-group">
            <input name="_password" type="password" v-model="password" id="_password"
              class="form-control" autocomplete="off" aria-describedby="inputPasswordHelp" placeholder="şifreniz" required="" />
            <label for="lblPassword">Parola</label>
        </div>
        <div class="form-check form-group custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="exampleCheck1" checked="checked"/>
            <label class="custom-control-label" for="exampleCheck1">Beni Hatırla</label>
        </div>
        <input type="submit" @click="handleSubmit" :disabled="loginning == true" v-bind:value="loginButtonText" id="Button_Login" class="btn btn-primary btn-block" />
      </form>
      <div class="footer-info">UTKU © Lenoi 2019</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'LoginPage',
  data () {
    return {
      username: '',
      password: '',
      peerip : '85.105.38.236',
      msg: 'Welcome to Your Vue.js App',
      loginning: false,
      loginStatus: false,
      loginMessage: null
    }
  },
  computed: {
    loginButtonText : function() { return this.loginning ? "Giriş Yapılıyor..." : "Giriş Yap" },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault();
      if (this.password.length > 0 && this.username.length > 0) {
        this.loginning = true
        this.$store.dispatch('login', { 'UserName': this.username, 'Password': this.password, 'PeerIP': this.peerip })
        .then(() => this.$router.push('/'))
        .catch(error => {
          this.loginStatus = true
          this.loginMessage = error.response.ErrorMessage
          this.loginning = false
          $(".alert").alert()
        })
      }
    },
    checkSession() {
      if(this.getSessionId != undefined || this.getSessionId != null) {
        this.$store.dispatch('checkSession')
        .then(resp => {
          if(resp.data.HasError == false)
            this.$router.push('/')
        })
        .catch(error => {
          console.log(error)
        })
      }
    },
    checkNotificationPermission() {
      console.log('ilk log noktası')
      if('Notification' in window) {
        console.log('A- Noktası')
        this.requestNotificationPermission()
      } else
        console.log('B- Noktası')
    },
    requestNotificationPermission() {
      console.log("1- Permission is " + Notification.permission);
      if(Notification && Notification.permission === 'default') {
        Notification.requestPermission(function (permission) {
          if(!('permission' in Notification)) {
            Notification.permission = permission;
            console.log("2A- Bildirim hazırlanıyor...")
            this.showSampleNotification()
          }
        });
      } else if(Notification && Notification.permission === 'granted') {
        console.log("2B- Bildirim hazırlanıyor...")
        this.showSampleNotification()
      }
    },
    showSampleNotification() {
      this.desktopNotification()
    },
    desktopNotification() {
      if (Notification.permission === 'granted') {
        console.log("3- Bildirim gönderiliyor...")
        var text = "your Notification Body goes here";
        this.sendDesktopNotification(text);
      }
    },
    sendDesktopNotification(text) {
      let notification = new Notification('Your Page Title', {
        icon: '~/static/logo@2x.png',
        body: text,
        tag: 'soManyNotification'
      });
      console.log("4- Bildirim gönderildi.")
    }
  },
  mounted() {
    this.checkSession()
    //this.checkNotificationPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .bg {
    margin-left: -60px;
    margin-top: -80px;
    width: 100vw;
    height: 100vh;
    background-color: #F5f5f5;
  }

  #login {
    width: 308px;
    position: absolute;
    left: 50%;
    margin-left: -184px;
    margin-top: 140px;
  }

  h4 {
    display: block;
    margin-bottom: 30px;
    text-align: center;
    width: 308px;
    font-weight: 300;
  }

  .font-small {
    font-size: .90rem;
    margin: 0 !important;
  }

  form.newform {
    -webkit-box-shadow: 0px 2px 1px 0px rgba(204,204,204,0.4);
    -moz-box-shadow: 0px 2px 1px 0px rgba(204,204,204,0.4);
    box-shadow: 0px 2px 1px 0px rgba(204,204,204,0.4);
    width: 308px;
    height: 280px;
    padding: 20px;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #d8dee2;
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .footer-info {
    display: block;
    width: 308px;
    font-size: 12px;
    font-weight: 300;
    color: #586069 !important;
    text-align: center;
  }

  .alert span {
    font-size: 14px;
  }

  /*
  .form-label-group {
    position: relative;
    margin-bottom: 1rem;
  }

  .form-group > input,
  .form-group > label {
    height: 3.125rem;
    padding: .75rem;
  }

  .form-group > label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    margin-bottom: 0;
    line-height: 1.5;
    color: #495057;
    pointer-events: none;
    cursor: text;
    border: 1px solid transparent;
    border-radius: .25rem;
    transition: all .1s ease-in-out;
  }

  .form-group input::-webkit-input-placeholder {
    color: transparent;
  }

  .form-group input:-ms-input-placeholder {
    color: transparent;
  }

  .form-group input::-ms-input-placeholder {
    color: transparent;
  }

  .form-group input::-moz-placeholder {
    color: transparent;
  }

  .form-group input::placeholder {
    color: transparent;
  }

  .form-group input:not(:placeholder-shown) {
    padding-top: 1.25rem;
    padding-bottom: .25rem;
  }

  .form-group input:not(:placeholder-shown) ~ label {
    padding-top: .25rem;
    padding-bottom: .25rem;
    font-size: 12px;
    color: #777;
  }

  @supports (-ms-ime-align: auto) {
    .form-group > label {
      display: none;
    }
    .form-group input::-ms-input-placeholder {
      color: #777;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .form-group > label {
      display: none;
    }
    .form-group input:-ms-input-placeholder {
      color: #777;
    }
  }*/

</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue